export default "__VITE_ASSET__Dd6Kp$m9__"